/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { useDtfStore } from "./store";
import { cn } from "tailwind-variants";

function DeliveryDate({
  hideAddressLine = false,
  isSameDay = false,
  compact = false,
  slots,
  ...restProps
}: any) {
  const store = useDtfStore();

  function isDtfSheet() {
    // @ts-expect-error TS(4111): Property 'isDtfSheet' comes from an index signatur... Remove this comment to see the full error message
    return store.isDtfSheet;
  }

  function productSlug() {
    // @ts-expect-error TS(4111): Property 'productSlug' comes from an index signatu... Remove this comment to see the full error message
    return store.productSlug;
  }

  // @ts-expect-error TS(6133): 'experiments' is declared but its value is never r... Remove this comment to see the full error message
  function experiments() {
    // @ts-expect-error TS(4111): Property 'experiments' comes from an index signatu... Remove this comment to see the full error message
    return store.experiments;
  }

  return (
    <div
      {...restProps}
      className={cn(
        "product-details-delivery-date-simple-transfers",
        restProps?.className,
        compact && "product-details-delivery-date-simple-transfers--compact"
      )}
      id="js-product-details-delivery-dates-simple-container"
      data-product-id={productSlug()}
      data-selected-color="Transfer"
      data-is-dtf={isDtfSheet()}
      data-enabled-shipping-enhancement-services={false}
      data-assignable="true"
    >
      <div className="product-details-delivery-date-simple-transfers__loading js-product-details-delivery-dates-simple-spinner">
        <span className="product-details-delivery-date-simple-transfers__loading-text">
          {" "}
          Getting Earliest Delivery Date{" "}
        </span>
        {slots?.dates?.()}
      </div>
      <div className="product-details-delivery-date-simple-transfers__wrapper js-product-details-delivery-dates-simple-wrapper hidden">
        <div className="product-details-delivery-date-simple-transfers__delivery js-product-details-delivery-dates-simple-shipment">
          {compact ? (
            <UseSvg
              className="product-details-delivery-date-simple-transfers__delivery-icon product-details-delivery-date-simple-transfers__delivery-icon--lightning"
              icon="lightning-1"
              data-testid="product-details-delivery-date-simple-transfers-delivery-icon"
            />
          ) : (
            <UseSvg
              className="product-details-delivery-date-simple-transfers__delivery-icon product-details-delivery-date-simple-transfers__delivery-icon--box"
              icon="box-jiffy-check"
              data-testid="product-details-delivery-date-simple-transfers-delivery-icon-1"
            />
          )}
          <span className="product-details-delivery-date-simple-transfers__delivery-date-label">
            {" "}
            Get it{" "}
            <span className="js-product-details-delivery-dates-simple-direct-value product-details-delivery-date-simple-transfers__delivery-date-value" />
          </span>
          {compact ? (
            <UseSvg
              className="product-details-delivery-date-simple-transfers__delivery-icon product-details-delivery-date-simple-transfers__delivery-icon--lightning-end"
              icon="lightning-1"
              data-testid="product-details-delivery-date-simple-transfers-delivery-icon-2"
            />
          ) : null}
        </div>
        <div className="product-details-delivery-date-simple-transfers__cutoff js-product-details-delivery-dates-simple-cutoff-wrapper">
          {" "}
          Order by{" "}
          <b className="js-product-details-delivery-dates-cutoff product-details-delivery-date-simple-transfers__cutoff-date">
            {" "}
            ...{" "}
          </b>
          <span className="js-expedite-shipping-note" />
        </div>
        {!hideAddressLine ? (
          <button
            className="product-details-delivery-date-simple-transfers__change-location-button js-deliver-to-toggle-modal"
            type="button"
            data-mixpanel-context="product_detail"
            data-testid="product-details-delivery-date-simple-transfers-change-location-button"
          >
            <UseSvg
              className="product-details-delivery-date-simple-transfers__change-location-button-icon"
              icon="marker-pin"
              data-testid="product-details-delivery-date-simple-transfers-change-location-button-icon"
            />
            <span className="product-details-delivery-date-simple-transfers__deliver-to-message js-deliver-to-pdp-addr">
              {" "}
              Select Your Address{" "}
            </span>
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default DeliveryDate;
